import { AxiosAPI } from './AxiosApi';
export class CommunicationsApi extends AxiosAPI {
    createKickStartFollowUp = async (body, options = {}) => {
        return this.POST(this.apiSchema.POST.communications.campaigns.kickstartFollowup(), body, options);
    };
}
export default new CommunicationsApi();
